import { formatInTimeZone } from 'date-fns-tz'

import { ISendRouteStrategyRequest, RouteDetailsStrategy } from '@/types/routeDetails'
import { IUserInfoResponse } from '@/types/user'

export const formatRouteStrategyRequestBody = (
    requestBody: ISendRouteStrategyRequest,
    userInfo?: IUserInfoResponse
): RouteDetailsStrategy | null => {
    if (!userInfo) {
        return null
    }

    return {
        id: crypto.randomUUID(),
        route: requestBody.route,
        strategy: requestBody.strategy,
        userShiftId: '',
        timestamp: formatInTimeZone(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        userShift: userInfo.lastSessionDetails,
    }
}
